import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewWrapperComponent } from '../../../ui/review-wrapper/review-wrapper.component';
import { CampaignDetailForm } from '../../../../services/campaign/campaign-details.service';

@Component({
  selector: 'app-campaign-details-review',
  standalone: true,
  imports: [ReviewWrapperComponent],
  templateUrl: './campaign-details-review.component.html',
  styleUrl: '../campaign-review.css',
})
export class CampaignDetailsReviewComponent {
  @Input({ required: true }) campaignDetails!: CampaignDetailForm;

  constructor(private router: Router, private route: ActivatedRoute) {}

  get goals(): string[] {
    return (this.campaignDetails?.goals ?? []).filter((goal) => !!String(goal ?? '').trim());
  }

  navigateToUrl() {
    this.router.navigate([], {
      relativeTo: this.route, // Stay on the current route
      queryParams: { step: 'campaign-details' }, // Add the new query param
    });
  }
}
